import { rejectNull } from "./rejectNull.js";

export async function rejectNullResult<T>(
  input: Promise<T>,
): Promise<NonNullable<T>> {
  const result = await input;
  return rejectNull(result);
}
